import { render, staticRenderFns } from "./DomainCharts.vue?vue&type=template&id=0bf7a684&scoped=true&"
import script from "./DomainCharts.vue?vue&type=script&lang=js&"
export * from "./DomainCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7a684",
  null
  
)

export default component.exports